module.exports = __webpack_public_path__ + "img/Slice170.58c213d1.png";